export default __webpack_public_path__ + "static/media/a7.0a4e2c70.png";